import { inView } from "motion";

(function () {
  let nav = null;
  let links = [];
  let sections = [];

  let groups = {};

  const updateActiveLink = (id) => {
    // Check if any link includes the ID in its href
    const matchingLinkExists = Array.from(links).some(link => link.href.includes(id));
  
    if (matchingLinkExists) {
      // Update classes based on the existence of the ID in hrefs
      links.forEach((link) => {
        if (link.href.includes(id)) {
          link.classList.add("active-menu-item");
        } else {
          link.classList.remove("active-menu-item");
        }
      });
    } 
  }
  

  const checkForValueInObject = (value) => {
    for (let id in groups) {
      if(Array.isArray(groups[id]) && groups[id].includes(value)) {
        updateActiveLink(id);
      }
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    nav = document.querySelector("nav.header__inline-menu");
    sections = document.querySelectorAll("main > section");
    links = nav.querySelectorAll("ul.list-menu--inline a[href^='#']");

    let currentAnchorId = null;
    sections.forEach((section) => {
      if (section.classList.contains("anchor")) {
        currentAnchorId = section.querySelector(".anchor").id;

        if (!groups.hasOwnProperty(currentAnchorId)) {
          groups[currentAnchorId] = [];
        }
      } else {
        if (groups && currentAnchorId) {
          groups[currentAnchorId].push(section);
        }
      }
    });

    sections.forEach((section) => {
      inView(section, () => {
        checkForValueInObject(section);

        return () => {};
      }, { amount: 0.5 });
    })
  });
})();